import React from "react";
import { Tooltip } from "./Tooltip";
import { useTimeAgo } from "../hooks/useTimeAgo";
import { useLocalStorage } from "../hooks/useLocalStorage";

export const DateTime = ({ date }) => {
	const timeAgo = useTimeAgo(date);
	const [useLocalTime] = useLocalStorage("useLocalTime", false);
	
	const fullDate = useLocalTime 
		? new Date(date).toLocaleString(undefined, { 
				year: 'numeric',
				month: 'numeric', 
				day: 'numeric',
				hour: 'numeric',
				minute: '2-digit',
				second: '2-digit',
				timeZoneName: 'short'
			})
		: new Date(date).toUTCString();

	return (
		<Tooltip content={fullDate}>
			<span className="whitespace-nowrap">{timeAgo}</span>
		</Tooltip>
	);
};
